const FEATURED_PROJECT_NAMES = [
  'ASAPH',
  'Pikul Wallet (Release and developing)',
  'DLT Taxi Driver',
  'SCB Business Anywhere',
];

export default FEATURED_PROJECT_NAMES;
